const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const DisputeListReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_DISPUTE_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_DISPUTE_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_DISPUTE_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default DisputeListReducer;